/**
 * Best-effort company-logo helper. We don't store logos — we resolve them
 * client-side from the company slug via the public Clearbit Logo API.
 *
 * No keys, no tracking — Clearbit accepts unauthenticated GETs.
 */
export function companyLogo(company) {
  if (!company) return null;
  const slug = String(company)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "")
    .replace(/^the/, "");
  if (!slug) return null;
  return `https://logo.clearbit.com/${slug}.com`;
}

/** Initials fallback when the logo 404s. */
export function companyInitials(company) {
  if (!company) return "??";
  return String(company)
    .split(/[\s\-_/]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

/** Format a relative posted-time string (server gives us 'Today', '2d', etc.). */
export function formatPosted(posted) {
  if (!posted) return "—";
  return String(posted);
}
